import WorkLogForm from "../workLogForm";
//---------------------------------------------------
export default function IncidentReport({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Department & Lead On Site", type: "text", required: true},
        {title: "Date of Incident", type: "date", required: true},
        {title: "Client", type: "text", required: true},
        {title: "Site Contact (name & number)", type: "text", required: true},
        {title: "Job Site Address", type: "text", required: true},
        {title: "Incident Information", type: "textarea", required: true},
        {title: "What happened?", type: "textarea", required: true},
        {title: "Will we be going back to fix issue? (explain on No)", type: "radio", onNo: "textarea", required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            sendEmail
            correctiveActionNeed = {true}
            picsLimit = {0}
            items = {items}
            {...rest}
        />
    )    
}